// Tour search — progressive enhancement for the [data-tour-search] panel.
// Without this file the panel is an ordinary GET form pointing at /tours/search.
// With it, results are fetched as HTML and dropped into the page the visitor is
// already on. No-ops on pages with no panel, so it's safe in the site-wide bundle.
(function () {
    "use strict";

    var panels = document.querySelectorAll("[data-tour-search]");
    if (!panels.length) return;

    Array.prototype.forEach.call(panels, function (panel) {
        var form = panel.querySelector("form");
        // Looked up within the shared parent rather than as panel.nextElementSibling: the
        // panel's partial also emits the itinerary lightbox, and a sibling that moves is not
        // something this should be sensitive to.
        var results = panel.parentElement
            && panel.parentElement.querySelector("[data-tour-search-results]");
        if (!form || !results) return;

        var resultsUrl = panel.dataset.resultsUrl;
        if (!resultsUrl) return;
        var expansionUrl = panel.dataset.expansionUrl;

        // A block on the host page that the results stand in for — the destination page's
        // own "Coach tours visiting …" list. It is *detached* while results show, not hidden:
        // its tour cards build element ids from the slug, and Bootstrap resolves
        // data-bs-target across the whole document, so a hidden copy would steal the clicks
        // meant for an expanded search result. A marker holds its place for the restore.
        var replaced = panel.dataset.replaces
            ? document.querySelector(panel.dataset.replaces)
            : null;
        var replacedMarker = replaced ? document.createComment("tour-search-replaced") : null;

        function detachReplaced() {
            if (!replaced || !replaced.parentNode) return;
            replaced.parentNode.insertBefore(replacedMarker, replaced);
            replaced.remove();
        }

        function restoreReplaced() {
            if (!replaced || replaced.parentNode || !replacedMarker.parentNode) return;
            replacedMarker.parentNode.insertBefore(replaced, replacedMarker);
            replacedMarker.remove();
        }
        var submit = form.querySelector("button[type=submit]");
        // Read before anything is injected: content already in the container means the page
        // was served with default results in it, so Clear goes back to those rather than to
        // an empty panel. Derived from the markup itself, so the two can't fall out of step.
        var hasDefaults = results.children.length > 0;
        var busy = false;
        // The current order. The sort buttons live outside the form and reach it via their
        // `form` attribute, so they arrive as the submit event's submitter rather than in
        // FormData; the chosen value is copied into this hidden field, which then rides
        // along with every later search — so changing a filter keeps the order.
        var sortInput = form.querySelector("[data-tour-search-sort-input]");

        function query() {
            return new URLSearchParams(new FormData(form)).toString();
        }

        // Whether anything is actually filtered. Sorting on its own isn't a search, so it
        // shouldn't offer a "Clear search".
        function hasFilters() {
            var values = new FormData(form);
            return ["destination", "from", "to"].some(function (name) {
                return (values.get(name) || "") !== "";
            });
        }

        // Injected markup misses the page-load pass, so the shared initialisers are re-run
        // over just the new subtree. Each one skips nodes it has already handled.
        function enhance(root, immediate) {
            var cp = window.coachPotato;
            if (!cp) return;
            // The maps bundle loads on first use (site.js), so wait for it before drawing.
            if (cp.loadMaps && root.querySelector(".tour-map[data-tour-map]")) {
                cp.loadMaps()
                    .then(function () { if (cp.initTourMaps) cp.initTourMaps(root, immediate); })
                    .catch(function () { /* map unavailable; the rest of the card still works */ });
            }
            if (cp.initTourGalleries) cp.initTourGalleries(root);
            if (cp.initItineraryPhotos) cp.initItineraryPhotos(root);
        }

        function setBusy(on) {
            busy = on;
            results.setAttribute("aria-busy", on ? "true" : "false");
            panel.classList.toggle("is-busy", on);
            if (submit) submit.disabled = on;
            // The sort buttons sit in the results area, so they need disabling too.
            results.querySelectorAll("[data-tour-search-sort]").forEach(function (button) {
                button.disabled = on;
            });
        }

        // Fetches a rendered fragment. Resolves with a DocumentFragment holding *every* top-level
        // node the server sent — an expanded itinerary is followed by its own image-credits
        // block, and dropping that would drop attribution the photo licences require — or null
        // on failure, so the caller falls back to a normal navigation rather than dead-ending.
        function fetchResults(url) {
            return fetch(url, { headers: { "X-Requested-With": "fetch" } })
                .then(function (response) {
                    if (!response.ok) throw new Error(response.status);
                    return response.text();
                })
                .then(function (html) {
                    var template = document.createElement("template");
                    template.innerHTML = html;
                    return template.content.firstElementChild ? template.content : null;
                })
                .catch(function () { return null; });
        }

        // Injected results always stand in for the host page's own list; only a clear puts
        // that back. `focusHeading` is off for the restore-the-defaults pass, where focus
        // belongs on the form the visitor just reset.
        function show(fragment, focusHeading) {
            // Release any maps in the outgoing results before they leave the DOM.
            if (window.coachPotato && window.coachPotato.destroyTourMaps) window.coachPotato.destroyTourMaps(results);
            // Inserting a DocumentFragment empties it, so query the container afterwards.
            results.replaceChildren(fragment);
            results.hidden = false;
            detachReplaced();

            var clearButton = results.querySelector("[data-tour-search-clear]");
            if (clearButton) clearButton.hidden = !hasFilters();

            enhance(results);

            var heading = results.querySelector("[data-tour-results-heading]");
            if (heading && focusHeading) heading.focus();
        }

        // Runs whatever the form currently holds.
        function run(focusHeading, onFail) {
            if (busy) return;
            setBusy(true);
            fetchResults(resultsUrl + "?" + query()).then(function (fragment) {
                setBusy(false);
                if (!fragment) { onFail(); return; }
                show(fragment, focusHeading);
            });
        }

        function clear() {
            form.reset();
            // reset() doesn't touch a hidden field's value, so the order is cleared by hand.
            if (sortInput) sortInput.value = "";
            var first = form.querySelector("select");

            if (hasDefaults) {
                // Back to the soonest departures the page opened with.
                run(false, function () { window.location.reload(); });
            } else {
                if (window.coachPotato && window.coachPotato.destroyTourMaps) window.coachPotato.destroyTourMaps(results);
                results.replaceChildren();
                results.hidden = true;
                restoreReplaced();
            }

            if (first) first.focus();
        }

        form.addEventListener("submit", function (event) {
            event.preventDefault();
            // A sort button submits this form from outside it; its value arrives here.
            var submitter = event.submitter;
            if (submitter && submitter.name === "sort" && sortInput) sortInput.value = submitter.value;

            var search = query();
            // Couldn't fetch — let the form do what it would have done anyway.
            run(true, function () { window.location.href = form.action + "?" + search; });
        });

        // Opens or closes one result's itinerary. The panel holds the same card body the
        // destination page renders, fetched on demand — so a result list costs one light
        // query, and only an opened row pays for a map and a gallery.
        function expand(toggle) {
            var row = toggle.closest(".tour-result");
            var target = row && row.querySelector("[data-tour-search-panel]");
            if (!target || busy) return;

            if (toggle.getAttribute("aria-expanded") === "true") {
                if (window.coachPotato && window.coachPotato.destroyTourMaps) window.coachPotato.destroyTourMaps(target);
                target.replaceChildren();
                target.hidden = true;
                toggle.setAttribute("aria-expanded", "false");
                toggle.textContent = "See itinerary";
                return;
            }

            setBusy(true);
            // The row's own URL carries the months it was searched with, so the card fades
            // the same dates the search excluded — not whatever the form holds right now.
            fetchResults(toggle.dataset.tourExpansionUrl
                    || expansionUrl + "/" + encodeURIComponent(toggle.dataset.tourSlug))
                .then(function (fragment) {
                    setBusy(false);
                    if (!fragment) {
                        // Couldn't fetch — follow the link, which renders the row expanded.
                        window.location.href = toggle.getAttribute("href");
                        return;
                    }
                    // Card body plus, as a second root node, its image-credits block.
                    target.replaceChildren(fragment);
                    target.hidden = false;
                    toggle.setAttribute("aria-expanded", "true");
                    toggle.textContent = "Hide itinerary";
                    // Drawn at once: the visitor asked for this itinerary explicitly.
                    enhance(target, true);
                });
        }

        // A destination page's "When to go" tiles: each is a link to the same search narrowed to
        // one month. Run it here instead, in the panel the page already has. One panel per page,
        // so listening on the document is safe. Falls back to the link if the month isn't offered.
        document.addEventListener("click", function (event) {
            var tile = event.target.closest("[data-tour-search-month]");
            if (!tile) return;
            var month = tile.dataset.tourSearchMonth;
            var from = form.querySelector("select[name=from]");
            var to = form.querySelector("select[name=to]");
            var offered = function (select) {
                return select && Array.prototype.some.call(select.options, function (o) { return o.value === month; });
            };
            if (!offered(from) || !offered(to) || busy) return;

            event.preventDefault();
            from.value = month;
            to.value = month;
            form.requestSubmit();
            panel.scrollIntoView({ behavior: "smooth", block: "start" });
        });

        // Delegated: every control lives inside fragments we replace wholesale.
        results.addEventListener("click", function (event) {
            var clearButton = event.target.closest("[data-tour-search-clear]");
            if (clearButton) {
                event.preventDefault();
                clear();
                return;
            }

            var toggle = event.target.closest("[data-tour-search-expand]");
            if (toggle) {
                event.preventDefault();
                expand(toggle);
                return;
            }

            var more = event.target.closest("[data-tour-search-more]");
            if (!more || busy) return;
            event.preventDefault();
            setBusy(true);

            // The link is a real next-page URL; ask for the same page as a fragment and
            // append its rows, so "show more" adds to the list instead of replacing it.
            var next = more.getAttribute("href").split("?")[1] || "";
            fetchResults(resultsUrl + "?" + next).then(function (fragment) {
                setBusy(false);
                if (!fragment) {
                    window.location.href = more.getAttribute("href");
                    return;
                }

                var list = results.querySelector(".tour-results__list");
                var added = fragment.querySelectorAll(".tour-results__list > li");
                if (list && added.length) {
                    Array.prototype.forEach.call(added, function (row) { list.appendChild(row); });
                }

                // The new rows' cover photos need their attribution too. Merge the page's credits
                // into the list already shown (skipping photos it already credits), or place the
                // whole block under the list when page one had nothing to credit.
                var newCredits = fragment.querySelector(".tour-results > .image-credits");
                var credits = results.querySelector(".tour-results > .image-credits");
                if (newCredits && credits) {
                    var creditList = credits.querySelector(".image-credits__list");
                    var seen = {};
                    creditList.querySelectorAll(".image-credits__item").forEach(function (item) {
                        seen[item.textContent] = true;
                    });
                    newCredits.querySelectorAll(".image-credits__item").forEach(function (item) {
                        if (!seen[item.textContent]) creditList.appendChild(item);
                    });
                } else if (newCredits && list) {
                    list.after(newCredits);
                }

                // Swap in the new page's "show more" (or drop it on the last page), and
                // keep the heading's count honest by leaving it alone — it's a total.
                var oldMore = results.querySelector(".tour-results__more");
                var newMore = fragment.querySelector(".tour-results__more");
                if (oldMore && newMore) oldMore.replaceWith(newMore);
                else if (oldMore) oldMore.remove();

                enhance(results);

                if (added.length) added[0].setAttribute("tabindex", "-1");
                if (added.length) added[0].focus();
            });
        });
    });
})();
